/* Privacy-friendly analytics by Plausible.
 * First-party production gate; the supplied collector/bootstrap are unchanged.
 * Form values are never collected; custom events use a separate gated adapter.
 */
(function () {
  'use strict';
  var config = document.currentScript;
  if (!config || config.dataset.ritualAnalyticsEnabled !== 'true') return;
  if (!['source', 'shopify'].includes(config.dataset.ritualAnalyticsContext)) return;
  if (location.protocol !== 'https:' ||
      location.hostname !== config.dataset.ritualProductionHost) return;
  if (window.self !== window.top) return;
  var query = new URLSearchParams(location.search);
  if (query.has('preview_theme_id')) return;
  var shopify = window.Shopify;
  if (shopify && (shopify.designMode || shopify.previewMode ||
      !shopify.theme || shopify.theme.role !== 'main')) return;
  if (config.dataset.ritualAnalyticsContext === 'shopify') {
    if (!shopify || !shopify.theme || shopify.theme.role !== 'main') return;
    var control = document.querySelector('[data-ritual-analytics-control]');
    if (!control || control.dataset.enabled !== 'true') return;
  }
  var collector = 'https://plausible.io/js/pa-xny_eykYWjPt0Jl-7xU6h.js';
  if (document.querySelector('script[src="' + collector + '"]')) return;
  var script = document.createElement('script');
  script.async = true;
  script.src = collector;
  document.head.appendChild(script);
  window.plausible=window.plausible||function(){(plausible.q=plausible.q||[]).push(arguments)},plausible.init=plausible.init||function(i){plausible.o=i||{}};plausible.init()
  window.RitualAnalyticsEnabled = true;
}());
